module.exports = __webpack_public_path__ + "static/video-211cbe03ffa1843c4a56c35781fc5511.mp4";